module.exports = __webpack_public_path__ + "img/BS35.047e5da4.svg";